import { render, staticRenderFns } from "./historyMessage.vue?vue&type=template&id=05ce7f7e&scoped=true&"
import script from "./historyMessage.vue?vue&type=script&lang=js&"
export * from "./historyMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ce7f7e",
  null
  
)

export default component.exports